import React from 'react';
import { Tag } from "../../../tag/Tag.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const MultiSelectTag = ({
  onClick,
  className,
  label,
  disabled,
  variant = 'secondary',
  title
}) => {
  return /*#__PURE__*/_jsx(Tag, {
    className: className,
    variant: variant,
    onClick: onClick,
    removable: !disabled,
    disabled: disabled,
    title: title ?? (typeof label === 'string' ? label : undefined),
    children: /*#__PURE__*/_jsx("span", {
      children: label
    })
  });
};